<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex md12 sm12 lg2 >
                <v-tooltip top>
                    <v-btn slot="activator" class="mt-4" absolute right fab dark top color="primary dark1" append :to="{path: 'add'}">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                    <span>{{$t('Core.Fields.add_new')}}</span>
                </v-tooltip>

            </v-flex>
            <v-flex md12 sm12 lg12>
                <record-books-table
                  @refresh="getItems"
                  @delete="deleteItem"
                  :total="total"
                  :loading="loading"
                  :items="items"
                  :recordBookTypes="recordBookTypes"
                  :documentTypes="documentTypes"
                  :realLocations="realLocations"
                  :transportTypes="transportTypes"
                ></record-books-table>
            </v-flex>
            <v-flex md12 sm12 lg12 mt-5>
              <deleted-record-books-table
                @refresh="getDeletedItems"
                @restore="restoreDeletedItem"
                @delete="deleteDeletedItem"
                :total="deletedTotal"
                :loading="deletedLoading"
                :items="deletedItems"
              ></deleted-record-books-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import RecordBooksTable from './recordBooks/Table'
  import DeletedRecordBooksTable from './recordBooks/DeletedTable'
  
  export default {
    name: "RecordBooks",
    components: { RecordBooksTable, DeletedRecordBooksTable },
    data: () => ({
      items: [],
      initial: true,
      loading: false,
      total: 0,
      pagination: {},
      deletedItems: [],
      deletedInitial: true,
      deletedLoading: false,
      deletedTotal: 0,
      deletedPagination: {},
      recordBookTypes: [],
      documentTypes: [],
      realLocations: [],
      transportTypes: []
    }),
    created () {
      this.getRecordBookTypes();
      this.getDocumentTypes();
      this.getRealLocations();
      this.getTransportTypes();
    },
    methods: {
      getRecordBookTypes(){
        this.setFetching(true);
        this.repositories.recordBookType.all().then((response) => {
          this.recordBookTypes = response.data.data;
        }).finally(() => {
            this.setFetching(false);
        });
      },
      getDocumentTypes(){
        this.setFetching(true);
        this.repositories.documentType.all().then((response) => {
          this.documentTypes = response.data.data;
        }).finally(() => {
            this.setFetching(false);
        });
      },
      getRealLocations(){
        this.setFetching(true);
        this.repositories.realLocation.all().then((response) => {
          this.realLocations = response.data.data;
        }).finally(() => {
            this.setFetching(false);
        });
      },
      getTransportTypes(){
        this.setFetching(true);
        this.repositories.transportType.all().then((response) => {
          this.transportTypes = response.data.data;
        }).finally(() => {
            this.setFetching(false);
        });
      },
      getItems(data = null){
        this.pagination = data;
        data.include = 'partner,importTransportType,exportTransportType,recordBookFiles,recordBookType,documentType,realLocation,user';
        if(this.initial){
          this.setFetching(true);
        }
        this.loading = true;
        this.repositories.recordBook.paginate(data)
          .then(response => {
            this.items = response.data.data;
            this.total = response.data.meta.pagination.total;
          }).finally(() => {
            this.loading = this.initial = false;
            this.setFetching(false);
          });
      },
      deleteItem(item){
        this.repositories.recordBook.delete(item.id)
          .then(response => {
            this.$toast.info(response.data.message);
            this.getItems(this.pagination);
            this.getDeletedItems(this.deletedPagination);
          })
      },
      getDeletedItems(data = null){
        this.deletedPagination = data;
        if(this.deletedInitial){
          this.setFetching(true);
        }
        this.deletedLoading = true;
        this.repositories.recordBook.deletedPaginate(data, 'partner,importTransportType,exportTransportType,recordBookFiles,recordBookType,documentType,realLocation,user')
          .then(response => {
            this.deletedItems = response.data.data;
            this.deletedTotal = response.data.meta.pagination.total;
          }).finally(() => {
            this.deletedLoading = this.deletedInitial = false;
            this.setFetching(false);
          });
      },
      restoreDeletedItem(itemId) {
        this.repositories.recordBook.deletedRestore(itemId)
          .then(response => {
            this.$toast.info(response.data.message);
            this.getItems(this.pagination);
            this.getDeletedItems(this.deletedPagination);
          })
      },
      deleteDeletedItem(item){
        this.repositories.recordBook.deletedDelete(item.id)
          .then(response => {
            this.$toast.info(response.data.message);
            this.getDeletedItems(this.deletedPagination);
          })
      }
    }
  }
</script>

<style scoped>

</style>